import { observer } from 'mobx-react';
import React, {
  SyntheticEvent,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import toast from 'react-hot-toast';
import { isValidTagId } from '../../../helpers/validate-helper';
import { FormattedMessage } from 'react-intl';
import { NavLink, useLocation, useParams } from 'react-router-dom';
// import noMessageIcon from '../../assets/Images/filterNodata.png';
import noMessageIcon from '../../../assets/Images/filterNodata.png';
import userSettingEnum from '../../../constants/enums/user-setting-enum';
import { useStore } from '../../../contexts/store-provider';
import {
  TagFilterDefaultSortColumnOrder,
  TagsFilterInitialState,
} from '../../../core/initialState/filter-initial-state';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import IPageInfo, {
  IMultiSelectOption,
  IPageLimitInfo,
} from '../../../models/ICommon';
import IDefaultColumSortOrder from '../../../models/IDefaultColumSortOrder';
import { ITagsFilter } from '../../../models/ITagsFilter';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Grid from '../../../shared-components/Grid/Grid';
import Pagination from '../../../shared-components/Grid/Pagination';
import FilterPopupHOC from '../../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../../shared-components/popup/delete/delete-popup-hoc';
import RoutesConstants from '../../../shared-components/routes/routes-constants';
import {
  FilterIcon,
  PlusIcon,
  RightArrowMove,
} from '../../../shared-components/svgs/svgs';
import { formatMessage } from '../../../translations/format-message';
import MaterialTagAssignFilter from './material-tag-assign-filter';
import Header from '../../../shared-components/header/header';
import { MultiSelect } from 'react-multi-select-component';
import {
  bOMGroups,
  IBomGroup,
  IBOMSearchFilter,
} from '../../../models/IBOMSearchFilter';
import config from '../../../helpers/config-helper';

const appConfig = config();
const showAddTrayInput = appConfig.REACT_APP_SHOW_ADD_TRAY_INPUT;

const MaterialTagAssign = (props: any) => {
  const [scannedItems, setScannedItems] = useState([]);
  const [scannedBarcode, setScannedBarcode] = useState('');
  const { taskId } = useParams<any>();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const processName = queryParams.get('processName');
  const { processStore, preferencesStore, operatorStore, bomStore } =
    useStore();
  const [tagRemoveRows, setTagRemoveRows] = useState([]);
  const [tagId, setTagId] = useState(''); //remove later
  const [removeTrayId, setRemoveTrayId] = useState(''); //remove later
  const [scannedData, setScannedData] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const {
    GetMaterialTagAssignDetailsService,
    materialTagAssignDetails,
    getMaterialTagAssignDetailsServiceState,
    katashikiList,
    MaterialTagAssignDetails,
  } = bomStore;
  const {
    processList,
    deleteProcessState,
    resetDeleteProcess,
    resetProcessDetail,
    addUpdateProcessState,
    resetAddUpdateProcessState,
  } = processStore;

  const {
    GetFilteredTrays,
    getFilteredTraysState,
    getAllFilteredTrays,
    resetFilteredTraysList,
    AssignTagService,
    assignTagState,
    GetTrayDetailsOnScan,
    getTrayDetailsOnScanState,
    trayDetailComputed,
    RemoveTagService,
    removeTagState,
    resetAssignTagState,
    resetRemoveTagState,
    resetGetTrayDetailsOnScanState,
    filteredTraysList,
    responseData,
  } = operatorStore;

  const {
    userSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
    setUserSetting,
  } = preferencesStore;

  let lang: string;
  const [scanBuffer, setScanBuffer] = useState('');
  const [lastKeyTime, setLastKeyTime] = useState(Date.now());
  const allFilteredTrays = getAllFilteredTrays;
  const [rows, setRows] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState('');
  const [openPanel, setOpenPanel] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    TagFilterDefaultSortColumnOrder
  );
  const [filterObj, setFilterObj] = useState<ITagsFilter>(
    TagsFilterInitialState
  );

  const pageLimitOptions: Array<number> = [10, 20, 50, 100];

  const [fontSizeClass, setFontSizeClass] = useState<string>(
    'opertor-normal-text'
  );
  const [activeSize, setActiveSize] = useState<'small' | 'normal' | 'large'>(
    'normal'
  );

  const [orderViewColumnFields, setOrderViewColumnFields] = useState<
    IMultiSelectOption[]
  >([]);
  const [selected, setSelected] = useState([]);

  const handleFontSizeChange = (size: 'small' | 'normal' | 'large') => {
    setActiveSize(size);

    if (size === 'small') {
      setFontSizeClass('opertor-small-text');
    } else if (size === 'large') {
      setFontSizeClass('opertor-text-large');
    } else {
      setFontSizeClass('opertor-normal-text');
    }
  };

  useEffect(() => {
    setRows(materialTagAssignDetails);
  }, [materialTagAssignDetails]);

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });
  const locationState = location.state as {
    state: IBOMSearchFilter;
    bOMGroups: bOMGroups;
  } | null;
  const groupsFromStorage = JSON.parse(
    localStorage.getItem('selectedRows') || 'null'
  );
  const normalizeBOMGroupsPayload = (payload: any): bOMGroups => {
    if (Array.isArray(payload)) {
      return payload as IBomGroup[];
    }
    if (payload?.BomGroups && Array.isArray(payload.BomGroups)) {
      return payload.BomGroups as IBomGroup[];
    }
    return [];
  };
  const groups = normalizeBOMGroupsPayload(
    locationState?.bOMGroups ?? groupsFromStorage
  );
  const normalizedGroups: IBomGroup[] = groups;
  const filter = locationState?.state;
  const initialKatashikiOptions: IMultiSelectOption[] = useMemo(
    () =>
      Array.from(
        new Set(
          groups.map((group) => group?.MaterialKatashiki)
          // .filter((katashiki): katashiki is string => !!katashiki)
        )
      ).map((katashiki) => ({
        label: katashiki.trim() == '' ? '--' : katashiki,
        value: katashiki,
      })),
    [groups]
  );
  const incomingKatashikiKey = useMemo(
    () =>
      initialKatashikiOptions
        .map((opt) => opt.value)
        .sort()
        .join('|'),
    [initialKatashikiOptions]
  );
  const getFilterObjectFromLocation = (): IBOMSearchFilter => {
    return (
      filter ||
      JSON.parse(localStorage.getItem('filter')) || {
        NextProcess: '-3',
        StartDate: '',
        EndDate: '',
        MaterialKatashiki: '',
        MaterialClassification: '',
        FreeTextSearch: '',
        Column: '',
        Order: '',
        SubContractorName: '',
      }
    );
  };

  useEffect(() => {
    localStorage.setItem(
      'materialKatashiki',
      JSON.stringify(incomingKatashikiKey)
    );
  }, []);

  const getFilteredTraysListServiceHandler = (
    isSearchClicked: boolean = false,
    isPageChanged?: boolean,
    filterQuery?: string
  ) => {
    const materialKatashiki = selected.map((option) =>
      option.value === '' ? ' ' : option.value
    );
    GetMaterialTagAssignDetailsService(
      Number(getTenantIdFromLocalStorage()),
      pageInfo.currentPage,
      pageLimitInfo.pageLimit,
      // selectedKatashiki
      [],
      materialKatashiki,
      true,
      getFilterObjectFromLocation(),
      groups
    );
  };

  useEffect(() => {
    if (initialKatashikiOptions.length > 0) {
      return;
    }
    if (katashikiList?.length > 0) {
      setOrderViewColumnFields(katashikiList);
      setSelected(katashikiList);
    }
  }, [katashikiList, initialKatashikiOptions.length]);

  useEffect(() => {
    setRows([]);
    setSelectedRow({});
    setSelectedId('');
    setPageInfo((prev) => ({
      ...prev,
      currentPage: 1,
      isPagerChange: false,
    }));
    setOrderViewColumnFields(initialKatashikiOptions);
    setSelected(initialKatashikiOptions);
    GetMaterialTagAssignDetailsService(
      Number(getTenantIdFromLocalStorage()),
      1,
      pageLimitInfo.pageLimit,
      [],
      [],
      false,
      getFilterObjectFromLocation(),
      groups
    );
    resetFilteredTraysList();
  }, [incomingKatashikiKey]);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      totalPages: MaterialTagAssignDetails?.PagingDetails?.TotalPages,
      currentPage: MaterialTagAssignDetails?.PagingDetails?.CurrentPage,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [MaterialTagAssignDetails]);

  // useEffect(() => {
  //   console.log(selectedId)
  //   debugger
  //   if (!selectedRow) return;
  //   const handleKeyDown = (e) => {
  //     const currentTime = Date.now();
  //     const timeDiff = currentTime - lastKeyTime;
  //     // If key delay is too long, treat it as a new scan
  //     //ARIF: WHY?? DOES SCAN NEED THIS?? TEST WITHOUT THIS WITH SCANNER
  //     if (e.target?.tagName === 'INPUT' || e.target?.tagName === 'BUTTON') {
  //       setScanBuffer(() => '');
  //     } else {
  //       if (timeDiff > 100) {
  //         setScanBuffer(() => e.key);
  //       } else {
  //         setScanBuffer((prev) => prev + e.key);
  //       }
  //     }
  //     setLastKeyTime(currentTime);

  //     if (e.key === 'Enter') {
  //       debugger
  //       const stringsToReplace = ['Shift', 'CapsLock', 'Tab'];
  //       const cleanedScan = scanBuffer.replace(
  //         new RegExp(stringsToReplace.join('|'), 'g'),
  //         ''
  //       );
  //       // Proceed with the cleaned scan value
  //       if (taskId === '-2' && cleanedScan.length > 0) {
  //         GetTrayDetailsOnScan(
  //           Number(getTenantIdFromLocalStorage()),
  //           cleanedScan
  //         );
  //       } else {
  //         if (cleanedScan?.length != 12) {
  //           //return;
  //         } else if (selectedRow?.AssignedId?.length === 0) {
  //           //alert(formatMessage('enter_valid_tag_id'));
  //         }
  //         // toast.error('Please scan a tag id')
  //         // toast.error(formatMessage('enter_valid_tag_id'));
  //         // else {
  //         //   alert(formatMessage('enter_valid_tag_id'));
  //         // }
  //         if (cleanedScan.length === 12) {
  //           setRows((prevRows) =>
  //             prevRows.map((row) =>
  //               row.TrayId === selectedId
  //                 ? { ...row, AssignedId: cleanedScan }
  //                 : row
  //             )
  //           );
  //         }
  //         // else if (cleanedScan.length >= 4) {
  //         //   toast.error(formatMessage('enter_valid_tag_id'));
  //         // }
  //       }
  //       handleTask();
  //       setScanBuffer('');
  //     }
  //   };

  //   window.addEventListener('keydown', handleKeyDown);
  //   return () => window.removeEventListener('keydown', handleKeyDown);
  // }, [selectedRow, scanBuffer, lastKeyTime]);

  useEffect(() => {
    if (!selectedRow) return;

    let buffer = '';
    let lastTime = Date.now();

    const handleKeyDown = (e: any) => {
      if (!e.key) return;
      const currentTime = Date.now();
      const timeDiff = currentTime - lastTime;

      if (timeDiff > 100) {
        buffer = e.key;
      } else {
        buffer += e.key;
      }

      lastTime = currentTime;

      if (e.key === 'Enter') {
        const cleanedScan = buffer.replace(/Shift|CapsLock|Tab|Enter/g, '');

        if (isValidTagId(cleanedScan)) {
          setRows((prevRows) =>
            prevRows.map((row) =>
              row.TrayId === selectedId ? { ...row, TagId: cleanedScan } : row
            )
          );
        } else {
          toast.error(formatMessage('enter_valid_tag_id'));
        }
        handleTask();
        buffer = '';
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedRow, selectedId]);

  useEffect(() => {
    if (materialTagAssignDetails && materialTagAssignDetails.length > 0) {
      setSelectedRow(materialTagAssignDetails[0]);
      setSelectedId(materialTagAssignDetails[0].TrayId);
    }
  }, [materialTagAssignDetails]);

  useEffect(() => {
    if (getFilteredTraysState.error) {
      toast.error(formatMessage(getFilteredTraysState.error));
      resetFilteredTraysList();
    }
  }, [getFilteredTraysState.error]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getFilteredTraysListServiceHandler(false, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getFilteredTraysListServiceHandler(false, true);
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (lang && language !== lang) {
      getFilteredTraysListServiceHandler(false, false);
    }
  }, [language]);

  useEffect(() => {
    if (assignTagState.error) {
      if (responseData === '') {
        toast.error(formatMessage(assignTagState.error));
      } else {
        const [beforeHash, afterHash] = responseData.split('#');
        if (beforeHash.length === 0 && afterHash.length === 0) {
          toast.error(formatMessage('could_not_connect_to_AIMS_server'));
        } else {
          toast.error(
            `${formatMessage(assignTagState.error)} ${
              beforeHash.length > 0
                ? `SuccessTrayId: ${beforeHash} | FailedTrayId: ${afterHash}`
                : `FailedTrayId: ${afterHash}`
            }`
          );
        }
      }
      // toast.error(
      //   `${
      //     beforeHash.length === 0 && afterHash.length === 0
      //       ? formatMessage('could_not_connect_to_AIMS_server')
      //       : formatMessage(assignTagState.error)
      //   } - ${
      //     beforeHash.length > 0
      //       ? `SuccessTrayId: ${beforeHash} | FailedTrayId: ${afterHash}`
      //       : `FailedTrayId: ${afterHash}`
      //   }`
      // formatMessage(
      //   `${assignTagState.error} ${
      //     beforeHash.length > 0
      //       ? `SuccessTrayId: ${beforeHash} | FailedTrayId: ${afterHash}`
      //       : `FailedTrayId: ${afterHash}`
      //   }`
      // )
      // );
      resetAssignTagState();
    }
  }, [assignTagState.error]);

  useEffect(() => {
    if (removeTagState.error) {
      const [beforeHash, afterHash] = responseData.split('#');
      toast.error(
        formatMessage(
          `${removeTagState.error} ${
            beforeHash.length > 0
              ? `SuccessTrayId: ${beforeHash} | FailedTrayId: ${afterHash}`
              : `FailedTrayId: ${afterHash}`
          }`
        )
      );

      resetRemoveTagState();
    }
  }, [removeTagState.error]);

  useEffect(() => {
    if (assignTagState.success) {
      toast.success(formatMessage('added_success'));
      setFilterObj({ ...TagsFilterInitialState });
      resetAssignTagState();
      getFilteredTraysListServiceHandler(false, false);
    }
  }, [assignTagState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.TrayId && row.TrayId === selectedRow.TrayId) {
      className = 'bg-row SelectedRow assign-tags';
    } else {
      if (row?.TagId) {
        className = 'assign-tags';
      } else {
        className = 'assign-tags';
      }
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any) => {
    // GetProcessByIdService(row.Id);
    setSelectedRow(row);
    setSelectedId(row.TrayId);
    // setSelectedId(row.Id);
    // if (selectedRow.Id === undefined || selectedRow.Id !== row.Id) {
    //   setOpenPanel(true);
    // } else {
    //   setOpenPanel(!openPanel);
    // }
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const handleTagClear = () => {
    if (selectedId === '') return;

    setRows((prev) => {
      return prev.map((item) => {
        if (item.TrayId === selectedId) {
          item.TagId = '';
        }
        return item;
      });
    });
    handleTask();
    props.deletePopupToggleHandler();
  };

  const closePanelhandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const handleTableChange = (type: any, newState: any) => {
    // if (isFirstLoad.current) {
    //   isFirstLoad.current = false;
    //   return;
    // }

    setColumnSortOrder((prevState) => ({
      ...prevState,
      dataField: newState.sortField,
      order: newState.sortOrder,
    }));
  };

  const onPageChanged = (pageNumber: number) => {
    closePanelHandler();
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const columns: any = [
    {
      dataField: 'serialNumber',
      text: formatMessage('serial_number'),
      classes: 'show-Elipses',
      isDummyField: true,
      formatter: (_: any, __: any, rowIndex: number) => rowIndex + 1,
      sort: false,
    },
    {
      dataField: 'TrayId',
      text: formatMessage('tray_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: false,
    },
    {
      dataField: 'EndUserOrderId',
      text: formatMessage('end_user_order_id_short'),
      sort: false,
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'TagId',
      text: formatMessage('assigned_tag_id'),
      classes: 'assign-tags',
      hidden: taskId === '-2',
      formatter: (cell) => {
        let highlightClass = '';
        if (cell) {
          highlightClass = 'tagID badge';
        }
        return <div className={`${highlightClass}`}>{cell}</div>;
      },
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },

    {
      dataField: 'OutOfStock',
      text: formatMessage('missing_parts'),
      sort: false,
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'ProductComment1',
      text: formatMessage('product_comment_1'),
      sort: false,
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'ProductComment2',
      text: formatMessage('product_comment_2'),
      sort: false,
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    // {
    //   dataField: '',
    //   formatter: CustomActionFormatter(actionIcons),
    //   text: formatMessage('actions'),
    //   classes: 'last-column',
    //   hidden: actionIcons.length > 0 ? false : true,
    //   isDummyField: true,
    // },
  ];

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: selectedId ? [selectedId] : [],
    onSelect: (row, isSelect) => {
      if (!isSelect) {
        return false;
      }
      setSelectedId(row.TrayId);
      setScannedBarcode('');
    },
    nonSelectable: rows.map((row) => row.TrayId),
    hideSelectAll: true,
    selectionRenderer: ({ checked }) => {
      return checked && <RightArrowMove />;
    },
  };

  const handleTask = () => {
    if (selectedId === '') return;

    const currentIndex = materialTagAssignDetails.findIndex(
      (row) => row.TrayId === selectedId
    );
    if (currentIndex < materialTagAssignDetails.length - 1) {
      setSelectedId(materialTagAssignDetails[currentIndex + 1].TrayId);
      setSelectedRow(materialTagAssignDetails[currentIndex + 1]);
    }
    // else {
    //   setSelectedId(allFilteredTrays[0].Id);
    //   setSelectedRow(allFilteredTrays[0]);
    // }

    // getFilteredTraysListServiceHandler();
  };

  useEffect(() => {
    if (rows.length === 0) {
      setSelectedId('');
    }
  }, [rows]);

  const handleSelectionChange = async (selectedOptions) => {
    if (selectedOptions.length === 0) {
      setSelected([]);
    } else {
      setSelected(selectedOptions);
    }
    setRows([]);
    setSelectedRow({});
    setSelectedId('');
    const rows = normalizeBOMGroupsPayload(
      JSON.parse(localStorage.getItem('selectedRows') || 'null')
    );
    GetMaterialTagAssignDetailsService(
      Number(getTenantIdFromLocalStorage()),
      pageInfo.currentPage,
      pageLimitInfo.pageLimit,
      [],
      selectedOptions.map((option) =>
        option.value === '' ? ' ' : option.value
      ),
      true,
      getFilterObjectFromLocation(),
      groups.length > 0 ? groups : rows
    );
  };

  return (
    <>
      <div className={`operator-wrapper ${fontSizeClass}`}>
        {props.showDeletePopup && (
          <DeletePopup
            title="clear_tag"
            modalSubmit={handleTagClear}
            modalClosed={props.deletePopupToggleHandler}
            message="message_clear_tag_confirm"
            isLoading={deleteProcessState.inProgress}
          />
        )}

        <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
          <div className="row align-items-center">
            <Header
              className="col"
              label="material_tag_assign"
              bomState={localStorage.getItem('filter')}
            />

            <div className="col-lg-7 col-md-6 col-sm-6">
              <div className="pe-4 d-flex justify-content-end">
                <>
                  {/* Do not remove */}
                  {/* remove later start */}
                  {showAddTrayInput && (
                    <>
                      <div className="mx-2">
                        <input
                          className="form-control"
                          type="text"
                          value={tagId}
                          placeholder="Tag Id"
                          onChange={(e) => {
                            setTagId(e.target.value);
                          }}
                        />
                      </div>
                      <div className="mx-2">
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            if (tagId.trim().length == 12) {
                              setRows((prevRows) =>
                                prevRows.map((row) =>
                                  row.TrayId === selectedId
                                    ? { ...row, TagId: tagId }
                                    : row
                                )
                              );
                            } else {
                              alert(formatMessage('enter_valid_tag_id'));
                            }
                            handleTask();
                            setTagId('');
                          }}
                        >
                          + {formatMessage('add')}
                        </button>
                      </div>
                    </>
                  )}
                  {/* remove later end */}
                  <MultiSelect
                    className="materialTagSelect filterSearchBom"
                    options={orderViewColumnFields}
                    value={selected}
                    onChange={handleSelectionChange}
                    labelledBy="Select"
                    // className={`multiselect-react product-select ${allTrayListData.length === 0 ? 'div-disabled' : ''}`}
                    valueRenderer={() => (
                      <>
                        <FilterIcon />
                      </>
                    )}
                    overrideStrings={{
                      selectAll: formatMessage('select_all_options'),
                      selectAllFiltered: formatMessage('select_all_filtered'),
                      search: formatMessage('search'),
                    }}
                    // isOpen={true}
                  />

                  <div
                    title={formatMessage('assign_tag')}
                    className="ms-2"
                  >
                    <a
                      className={`btn btn-secondary ${
                        selectedId === '' ||
                        !rows.some((item) => item.TagId?.trim())
                          ? 'disabled'
                          : ''
                      }`}
                      data-toggle="modal"
                      data-testid="modalbtn"
                      data-target="#addUser"
                      onClick={() => {
                        const assignedTags = rows
                          .map((item) => item.TagId?.trim())
                          .filter(Boolean);
                        const tagSet = new Set<string>();

                        const hasDuplicates = assignedTags.some((tag) => {
                          if (tagSet.has(tag)) {
                            return true;
                          }
                          tagSet.add(tag);
                          return false;
                        });

                        if (hasDuplicates) {
                          toast.error(formatMessage('multiple_tag_ids_found'));
                          return;
                        }
                        AssignTagService({
                          TenantId: Number(getTenantIdFromLocalStorage()),
                          TagTrays: rows.filter((item) => item.TagId),
                          IsTagReassigned: false,
                        });
                      }}
                    >
                      <span className="me-1">
                        {' '}
                        <PlusIcon />
                      </span>
                      {<FormattedMessage id="assign_tag" />}
                    </a>
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
        <div className={`${openPanel ? 'panelOpen' : ''}`}>
          <div className="card card-page">
            {(getMaterialTagAssignDetailsServiceState.inProgress ||
              assignTagState.inProgress) && (
              <FormLoader
                loading={
                  getMaterialTagAssignDetailsServiceState.inProgress ||
                  assignTagState.inProgress
                }
              />
            )}

            <div>
              {/* <MaterialTagAssignFilter
                initialValues={filterObj}
                submitHandler={filterHandler}
                filterParmas={filterParams}
                isFilterCleared={isFilterCleared}
                isLoading={false}
              />{' '} */}
              {rows && rows.length > 0 ? (
                <>
                  <div className="opertor-dummy">
                    <div className="tableDesign row-eq-height tableDevices p-3 material-tag-assign">
                      <div
                        className="table-responsive"
                        data-testid="table"
                      >
                        {rows && (
                          <Grid
                            data={rows}
                            columns={columns}
                            keyField="TrayId"
                            loading={false}
                            rowClasses={rowClassFormat}
                            rowEvents={{ onClick: rowEvents }}
                            hover={true}
                            onTableChange={handleTableChange}
                            selectRow={selectRow}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  {rows.length > 0 ? (
                    <div className="row no-gutters p-3 pt-0 tableFooter">
                      <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                        <FormattedMessage id="show" />
                        <select
                          data-testid="pageSelect"
                          className="pageLimit"
                          onChange={onPageLimitChanged}
                          value={pageLimitInfo.pageLimit}
                        >
                          {pageLimitOptions.map((op: any) => (
                            <option
                              key={op}
                              value={op}
                            >
                              {op}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                        <Pagination
                          isRefreshPage={false}
                          totalPages={pageInfo.totalPages}
                          pageLimit={pageLimitInfo.pageLimit}
                          onPageChanged={onPageChanged}
                          disablePagination={disablePagination}
                          setIsRefreshPage={setIsRefreshPage}
                          currentPage={pageInfo.currentPage}
                          totalRecords={
                            MaterialTagAssignDetails.PagingDetails.TotalRecords
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </>
              ) : (
                <div className="message tagAssignMessageMaterial">
                  <div className="d-flex message-area">
                    <div className="no-data-img">
                      <img
                        src={noMessageIcon}
                        alt=""
                        className="no_message"
                      />
                    </div>
                    <div>
                      <h3 className="fw-bold display-6">
                        {' '}
                        <FormattedMessage id="no_tray_tag" />
                      </h3>
                      <h4 className="mb-3">
                        {formatMessage('no_tray_assign_message')}
                      </h4>
                      {/* {isOperationPermittedRoleBase(
                          ModuleType.ProcessManagement,
                          'Add'
                        ) && (
                          <LoaderButton
                            text="add_process"
                            onClick={(event: any) =>
                              openAddProcessHandler({ Id: -1 }, event)
                            }
                          />
                        )} */}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterPopupHOC(DeletePopupHOC(observer(MaterialTagAssign)));
